export default (value, required = true) =>
    new Promise((resolve) => {
        if (!required && value.length === 0) {
            resolve(true);
        }

        if (value.length !== 12) {
            resolve(false);
        }

        value = value.slice(2);

        const month = parseInt(value.substring(2, 4));
        const day = parseInt(value.substring(4, 6));

        if (month > 12 || day > 31) {
            resolve(false);
        }

        resolve(true);
    });
